export const ExpensesTrackingEvents = {
  ReceiptUploaded: 'xxx - expenses - receipt uploaded',
  AttachmentManageButtonClick: 'xxx - expenses - clicked manage attachment (Manage)',
  AttachmentSelectButtonClick: 'xxx - expenses - clicked select attachment (Select)',
  AttachmentManageBulkButtonClick: 'xxx - expenses - clicked bulk attachment manage (Manage Selected)',
  AttachmentPreviewButtonClick: 'xxx - expenses - clicked preview attachment (Preview)',
  BillDeleteFromSimplifiedAttachmentViewClick: 'xxx - expenses - delete bill from shoebox ui clicked',
  BillSyncRetryButtonClick: 'xxx - expenses - sync retry clicked',
  CreatePurchaseClicked: 'xxx - expenses - create purchase click',
  CreateCreditNoteClicked: 'xxx - expenses - create credit note for purchase click',
  SupplierCreated: 'xxx - expenses - supplier created',
  SupplierCompanyCreatedManually: 'xxx - expenses - clicked on supplier create company manually',
  DuplicateDetected: 'xxx - expenses - duplicate detected',
  DuplicateReviewClicked: 'xxx - expenses - duplicate detected - review clicked',
  DuplicateKeepBothClicked: 'xxx - expenses - duplicate detected - keep both expenses cta clicked',
  DuplicateDeleteClicked: 'xxx - expenses - duplicate detected - delete duplicate cta clicked',
  DuplicateOpenDocumentClicked: 'xxx - expenses - duplicate detected - open document cta clicked',
}

export const EInvoiceLifecycleTrackingEvents = {
  ApproveCTAClicked: 'xxx - expenses - e-invoice approve cta clicked',
  RefuseCTAClicked: 'xxx - expenses - e-invoice refuse cta clicked',
  DisputeCTAClicked: 'xxx - expenses - e-invoice dispute cta clicked',
  SuspendCTAClicked: 'xxx - expenses - e-invoice suspend cta clicked',
  ActionSubmitted: 'xxx - expenses - e-invoice action submitted',
  ActionCancelled: 'xxx - expenses - e-invoice action cancelled',
}

export const EInvoiceLifecycleTrackingSources = {
  ExpensesEditor: 'expenses_editor',
  ReceiptPreview: 'receipt_preview',
} as const

export type EInvoiceLifecycleTrackingSource =
  (typeof EInvoiceLifecycleTrackingSources)[keyof typeof EInvoiceLifecycleTrackingSources]

export const ExpensesReceiptUploadSources = {
  ReceiptEmptyState: 'Receipt Empty State',
  ReceiptFullScreenDragAndDrop: 'Receipt Full Screen Drag and Drop',
  UploadFilesButton: 'Upload Files CTA',
  PurchaseListFullScreenDragAndDrop: 'Purchase List Full Screen Drag and Drop',
  PurchaseCreationDrop: 'Purchase Creation Drag and Drop',
  PurchaseCreationManualSelect: 'Purchase Creation Manual Select',
  PurchaseCreationInReconciliation: 'Quick Purchase Creation in Reconciliation',
}
